import { Flex } from 'foundations-components/components/Flex';
import { PurchaseMotionCTA } from 'purchase-motions-components/components/PurchaseMotionCTA/PurchaseMotionCTA';
import { useSelector } from 'react-redux';
import { APP } from '../../../v2/constants/tracking/App';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useBestApiNameFromProductConfigurations } from '../../../hooks/useBestApiNameFromProductConfigurations';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { currentSkuIdForProductSelector } from '../../../selectors/ProductsSelectors';
import { talkToSalesTypeSelector } from '../../../selectors/PurchaseMotionSelectors';
import { isTTSPurchaseMotion } from '../../../v2/utils/typeguards';
import { jsx as _jsx } from "react/jsx-runtime";
export const TalkToSalesFallback = ({
  apiName,
  skuId,
  screen,
  trackingSource
}) => {
  const isAppReady = useGlobalLoading();
  const isAppAuth = useSelector(isAppAuthSelector);
  const resolvedSkuId = useSelector(state => {
    if (!isAppReady) return null;
    return apiName ? currentSkuIdForProductSelector(state, {
      apiName
    }) : skuId;
  });
  const hookApiName = useBestApiNameFromProductConfigurations(resolvedSkuId ? [{
    skuId: resolvedSkuId,
    quantity: 1
  }] : []);
  const resolvedApiName = apiName || hookApiName;
  const trackingData = {
    app: APP,
    screen,
    uniqueId: `${trackingSource}-${resolvedApiName}`
  };
  const purchaseMotion = useAppSelector(state => talkToSalesTypeSelector(state));
  if (!resolvedSkuId || !resolvedApiName || !isAppAuth || !isTTSPurchaseMotion(purchaseMotion)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "stretch",
    children: /*#__PURE__*/_jsx(PurchaseMotionCTA, {
      apiName: resolvedApiName,
      location: 'MERCH_CARD',
      purchaseMotion: purchaseMotion,
      trackingData: trackingData,
      uiButtonProps: {
        use: 'primary',
        block: true
      }
    })
  });
};